import { Injectable } from '@angular/core';
import { Observable, forkJoin } from 'rxjs';
import { ProvidersHttpClient } from './providers-http-client';
import { Providers } from 'src/app/interfaces/interfaces.module';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class ProvidersApiService {
    constructor(private http: ProvidersHttpClient) {}

    public list(query: Providers.SearchProvidersQuery): Observable<Providers.Page<Providers.ProviderInfoModel>> {
        return this.http.post<Providers.Page<Providers.ProviderInfoModel>>('providers', query, true);
    }

    public get(id: string): Observable<Providers.ProviderModel> {
        return this.http.get<Providers.ProviderModel>('providers/' + id, true);
    }

    public getMany(ids: string[], showLoader: boolean = true): Observable<Providers.BasicProviderModel[]> {
        const query: Providers.GetManyBasicProviderModelsQuery = { providerIds: ids };
        const models$ = this.http.post<Providers.BasicProviderModels>('providers/many', query, showLoader);

        return models$.pipe(map(x => x.items));
    }

    public updateProfileAndActivate(id: string, updateModel: Providers.UpdateProviderProfileModel): Observable<void> {
        return this.http.post<void>('providers/' + id + '/updateAndActivate', updateModel);
    }

    public approveProfile(providerId: string, profileId: string): Observable<void> {
        return this.http.post<void>(`providers/${providerId}/profile/${profileId}/approve`, null);
    }

    public rejectProfile(providerId: string, profileId: string, reason: string): Observable<void> {
        const command: Providers.RejectProviderProfileReasonModel = {
            rejectionReason: reason
        };

        return this.http.post<void>(`providers/${providerId}/profile/${profileId}/reject`, command);
    }

    public getProviderPhotoInfo(providerId: string, profileId: string): Observable<Providers.PhotoInfo> {
        return this.http.get<Providers.PhotoInfo>(`providers/${providerId}/profile/${profileId}/photoInfo`);
    }
}
